import { FocusableOption } from "@angular/cdk/a11y";
import { Directive, ElementRef, Input } from "@angular/core";
import mixinDisabled from "../../mixins/disabled";
import { PhxSelectOption } from "./select.types";

const baseMixin = mixinDisabled(
  class {
    constructor() { }
  },
);

@Directive({
  selector: '[selectFocusableItem]',
  inputs: ['disabled'],
  host: {
    role: 'menuitem',
    '[attr.tabindex]': 'disabled || option.groupLabel ? null : -2',
  }
})
export class SelectFocusableItemDirective extends baseMixin implements FocusableOption {
  /**
   * used as a context to select this option through keyboard, selection is handled in phx-select.
   */
  @Input() public option: PhxSelectOption;

  public focus(): void {
    this.elementRef.nativeElement?.focus();
  }

  constructor(public elementRef: ElementRef<HTMLElement>) {
    super();
  }

}